const exportedObject = {
  getProcedimientosPssData: {},
  getProcedimientosPssLoading: false,
  getProcedimientosPssError: null,

  getMedicosData: {},
  getMedicosLoading: false,
  getMedicosError: null,

  actualizarPrestadorStandVirtualData: {},
  actualizarPrestadorStandVirtualLoading: false,
  actualizarPrestadorStandVirtualError: null
};

export default exportedObject;
